'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Progress = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\n\t> progress[value] {\n\t\tflex-grow: 1;\n\t\tappearance: none;\n\t\tborder: none;\n\t\theight: ', ';\n\n\t\t::-webkit-progress-bar {\n\t\t\tbackground-color: ', ';\n\t\t\tborder-radius: 9px;\n\t\t}\n\t\n\t\t::-webkit-progress-value {\n\t\t\tbackground-color: ', ';\n\t\t\tborder-radius: 9px;\n\t\t}\n\t\n\t\t::-moz-progress-bar {\n\t\t\tbackground-color: ', ';\n\t\t\tborder-radius: 9px;\n\t\t}\n\t}\n'], ['\n\tdisplay: flex;\n\n\t> progress[value] {\n\t\tflex-grow: 1;\n\t\tappearance: none;\n\t\tborder: none;\n\t\theight: ', ';\n\n\t\t::-webkit-progress-bar {\n\t\t\tbackground-color: ', ';\n\t\t\tborder-radius: 9px;\n\t\t}\n\t\n\t\t::-webkit-progress-value {\n\t\t\tbackground-color: ', ';\n\t\t\tborder-radius: 9px;\n\t\t}\n\t\n\t\t::-moz-progress-bar {\n\t\t\tbackground-color: ', ';\n\t\t\tborder-radius: 9px;\n\t\t}\n\t}\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColor = _utils2.default.getColor,
    getLightenedColor = _utils2.default.getLightenedColor;


var StyledProgress = _styledComponents2.default.div(_templateObject, function (props) {
	return props.height;
}, function (props) {
	return getLightenedColor(props);
}, function (props) {
	return getColor(props);
}, function (props) {
	return getLightenedColor(props);
});

var Progress = function Progress(props) {
	var height = props.height,
	    max = props.max,
	    value = props.value;


	return _react2.default.createElement(
		StyledProgress,
		_extends({
			height: height
		}, props),
		_react2.default.createElement('progress', {
			max: max,
			value: value })
	);
};

Progress.propTypes = {
	height: _propTypes2.default.string,
	max: _propTypes2.default.number.isRequired,
	value: _propTypes2.default.number.isRequired
};

Progress.defaultProps = {
	height: '8px'
};

exports.Progress = Progress;